<span class="compliance-status-container" *transloco="let t; prefix: 'compliance.shared.statusIndicator'">
   <!-- Compliant -->
  @if(complianceItem.compliantCount) {
    <span class="compliant-count">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z" fill="#50AD41"/>
      </svg>
      <label>{{ t('compliantCount', { count: complianceItem.compliantCount }) }}</label>
    </span>
  }
  <!-- Expiring Soon -->
  @if(complianceItem.expiringSoonCount) {
    <span class="expiring-soon-count">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM10.194 11.1406L7.33203 8.2786V4.0026H8.66536V7.7266L11.1367 10.1979L10.194 11.1406Z" fill="#F4BC2B"/>
      </svg>
      <label>{{ t('expiringSoonCount', { count: complianceItem.expiringSoonCount }) }}</label>
    </span>
  }
  <!-- Non-Compliant -->
  @if(complianceItem.nonCompliantCount) {
    <span class="non-compliant-count">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.96736 1.33594C4.3087 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6607 1.33594 7.96736 1.33594ZM8.66536 11.3359H7.33203V10.0026H8.66536V11.3359ZM8.66536 8.66927H7.33203V4.66927H8.66536V8.66927Z" fill="#FF7F00"/>
      </svg>
      <label>{{ t('nonCompliantCount', { count: complianceItem.nonCompliantCount }) }}</label>
    </span>
  }
</span>